import styled from 'styled-components';

import { SkeletonStack } from 'basics/loaders/ContentPlaceholder/ContentPlaceholder.styled';

export const Options = styled(SkeletonStack)`
    margin-top: 5.8rem;
`;
